import { restClient } from '../client';
import { TimeRange } from '@uplift/types';


export type NormalizeTimesInput = {
  ranges: TimeRange[];
  squash?: boolean;
};


export type NormalizeTimesOutput = {
  ranges: TimeRange[];
};


export const normalizeTimes = restClient.createRequest<NormalizeTimesInput, NormalizeTimesOutput>({
  url: '/api/v1/availability_template/normalize_ranges',
  method: 'POST',
});
